import { capitalize, isFinite } from 'lodash'

import { nanoid } from 'nanoid';

const OPTI_RECS_PRODNAME = "Product Recommendations"
/*
* This is old function to observe DOM Element
*/
const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
const isMacOS = macosPlatforms.indexOf(window.navigator.platform) !== -1;
const isFirefox = typeof InstallTrigger !== 'undefined';
const fireFoxClass = (isFirefox && !isMacOS) ? 'firefox-detected' : '';

// eslint-disable-next-line no-useless-escape
const regexValidString = /^[a-zA-Z0-9\|\-\!\"\#\$\%\&\'\(\)\*\+\,\.\/\[\\\]\^\_\`\{\}\~\‚\„\:\;\=\?\@€ŠŒŽšœžŸ¡¢£¥¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ\s]*$/;
const regexNoLeadingSpace = /^\S.*/;
const regexAlphaNumSpace = /^[a-zA-Z0-9\s]*$/;
const allSupportedLocales = ["en", "af", "ar-dz", "ar-kw", "ar-ly", "ar-ma", "ar-sa", "ar-tn", "ar", "az", "be", "bg", "bm", "bn", "bo", "br", "bs", "ca", "cs", "cv", "cy", "da", "de-at", "de-ch", "de", "dv", "el", "en-au", "en-ca", "en-gb", "en-ie", "en-il", "en-nz", "en-us", "eo", "es-do", "es-us", "es", "et", "eu", "fa", "fi", "fo", "fr-ca", "fr-ch", "fr", "fy", "gd", "gl", "gom-latn", "gu", "he", "hi", "hr", "hu", "hy-am", "id", "is", "it", "ja", "jv", "ka", "kk", "km", "kn", "ko", "ky", "lb", "lo", "lt", "lv", "me", "mi", "mk", "ml", "mn", "mr", "ms-my", "ms", "mt", "my", "nb", "ne", "nl-be", "nl", "nn", "pa-in", "pl", "pt-br", "pt", "ro", "ru", "sd", "se", "si", "sk", "sl", "sq", "sr-cyrl", "sr", "ss", "sv", "sw", "ta", "te", "tet", "tg", "th", "tl-ph", "tlh", "tr", "tzl", "tzm-latn", "tzm", "ug-cn", "uk", "ur", "uz-latn", "uz", "vi", "x-pseudo", "yo", "zh", "zh-cn", "zh-hk", "zh-mo", "zh-my", "zh-sg", "zh-tw", "no"];

function observe(root: HTMLElement) {
  // const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  // const isMacOS = macosPlatforms.indexOf(window.navigator.platform) !== -1;
  // const isFirefox = typeof InstallTrigger !== 'undefined';
  // const fireFoxClass = (isFirefox&&!isMacOS) ? 'firefox-detected':'';
  const navigationContainerClasses = 'epi-navigation-container epi-navigationContainer';
  // This observer is responsible for copying the classes when the classes have changed
  var navObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach(mutation => {
      root.className = mutation.target.className + ' ' + navigationContainerClasses + ' ' + fireFoxClass;
    });
  });
  // This observer is responsible for copying the classes when the navigation is added to the root node
  var rootObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        root.className = mutation.addedNodes[0].className + ' ' + navigationContainerClasses + ' ' + fireFoxClass;
        // observe the newly added node for class changes that will need to be mirrored in the root
        navObserver.observe(mutation.addedNodes[0], { attributes: true });
      }
    });
  });

  rootObserver.observe(root, { childList: true });
}

const createPage = (tagName, callbackFn) => {
  customElements.define(tagName, class extends HTMLElement {
    connectedCallback() {
      callbackFn(this);
    }
  });
};

function parseDateyyyyMMddhhmm(dateTime) {
  // Always treat as UTC when the input string has no timezone designator.
  if (!isNaN(dateTime))
    return new Date(dateTime)

  const trimmed = dateTime.trim().replace(' ', 'T');
  const hasTz = /(?:[Zz]|[+-]\d{2}(?::?\d{2})?)$/.test(trimmed);
  return new Date(hasTz ? trimmed : trimmed + 'Z');
}

const formatCurrency = (amount, currency = 'VND', locale = 'vi-vi', isLong = true) => {
  try {
    return new Intl.NumberFormat(locale.replace('_', '-').toLowerCase(), {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      notation: isLong ? 'standard' : 'compact',
      compactDisplay: isLong ? 'long' : 'short',
    }).format(amount)
  } catch (error) {
    return amount
  }
}

function zeroPad(num, places) {
  return String(num).padStart(places, '0')
}

function getDateString(milis, locale) {
  const date = new Date(milis);
  return zeroPad(date.getDate(), 2) + '-' + zeroPad(date.getMonth() + 1, 2) + '-' + date.getFullYear()
}

function getOffsetHours(timeZone, date = new Date()) {
  const str = new Intl.DateTimeFormat('en-US', {
    timeZone, timeZoneName: 'longOffset',
  }).format(date).split(' ').pop();

  const m = str.match(/GMT([+-])(\d{2}):(\d{2})/);
  if (!m) return 0;
  const sign = m[1] === '+' ? 1 : -1;
  return sign * (Number(m[2]) + Number(m[3]) / 60);
}

const formatNumber2Digits = (value, locale = 'en-gb', minimumFractionDigits = 0, maximumFractionDigits = 2) => {
  try {
    const formatter = new Intl.NumberFormat(locale.replace('_', '-').toLowerCase(), {
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
    });
    return formatter.format(value);
  } catch (error) {
    return value
  }
}

const formatNumberByLocale = (value, locale = 'en-GB') => {
  try {
    const formatter = new Intl.NumberFormat(locale.replace('_', '-').toLowerCase(), { maximumFractionDigits: 2 });
    return formatter.format(value);
  } catch (error) {
    return value
  }
}

function formatDateTime(dateTime, locale, useUTC = true) {
  if (locale && dateTime) {
    let tLocale = locale.replace('_', '-');
    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: "numeric",
      minute: "numeric",
      hourCycle: 'h23',
    };
    if (useUTC) {
      options.timeZone = 'UTC';
    }
    const dateTimeFormat = new Intl.DateTimeFormat(tLocale, options);
    if (dateTime.toString() !== 'Invalid date')
      return dateTimeFormat.format(parseDateyyyyMMddhhmm(dateTime));
    else
      return dateTime.toString()
  }

  return ''; // Invalid datetime will not be shown, some case input datetime is null
}

function formatDateFromyyyyMMdd(dateStr, locale, useUTC = true) {
  if (!dateStr || typeof dateStr !== 'string') return '';

  try {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (isNaN(date)) return 'Invalid date';

    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    };
    if (useUTC) {
      options.timeZone = 'UTC';
    }
    const formatter = new Intl.DateTimeFormat(locale.replace('_', '-'), options);
    return formatter.format(date);
  } catch (e) {
    return 'Invalid date';
  }
}

function formatDate(dateTime, locale, useUTC = true) {
  if (locale && dateTime) {
    let tLocale = locale.replace('_', '-');
    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    };
    if (useUTC) {
      options.timeZone = 'UTC';
    }
    const dateTimeFormat = new Intl.DateTimeFormat(tLocale, options);
    if (dateTime.toString() !== 'Invalid date')
      return dateTimeFormat.format(parseDateyyyyMMddhhmm(dateTime));
    else
      return dateTime.toString()
  }

  return ''; // Invalid datetime will not be shown, some case input datetime is null
}

function time24toAM(timeParam) {
  // Check correct time format and split into components
  let time = timeParam?.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeParam];

  if (time?.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(''); // return adjusted time or original string
}

const checkDateBefore = (currentDatetime, targetDatetime) => {
  const currentDate = parseDateyyyyMMddhhmm(currentDatetime);
  const targetDate = parseDateyyyyMMddhhmm(targetDatetime);

  return (currentDate.getTime() > targetDate.getTime());
}

function generateKey(pre) {
  return `${pre}_${Math.random()}_${new Date().getTime()}`;
}

function checkIfValidIP(str) {
  const regexExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){2}(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|\*)\.(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|\*)$/gi;

  return regexExp.test(str);
}

function getDisplayName(Component) {
  return (
    Component.displayName ||
    Component.name ||
    (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown')
  );
}

function getNameFromEmail(userEmail, namePart = 0) {
  let str = userEmail?.split('@')[0] || ''
  if (str && str.includes('.')) {
    const substr = str.split('.')

    if (namePart === 1)
      return capitalize(substr[0])
    else if (namePart === 2)
      return capitalize(substr[1])
    else
      return capitalize(substr[0]) + ' ' + capitalize(substr[1])
  } else {
    return capitalize(str)
  }
}

function detectLang() {
  let lng = 'en'
  if (window.perPortal) {
    switch (window.perPortal.locale.toLowerCase()) {
      case 'en_gb':
        lng = 'en'
        break
      case 'en_us':
        lng = 'en_us'
        break
      case 'de':
        lng = 'de'
        break
      case 'no':
        lng = 'no'
        break
      case 'sv':
        lng = 'sv'
        break

      default:
        break
    }
  }
  return lng
}

const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string)

const isValid = (string) => {
  if (!string)
    return true
  //prevent XSS attack
  var e = /[^a-zA-Z0-9\|\-\!\"\#\$\%\&\'\(\)\*\+\,\.\/\[\\\]\^\_\`\{\}\~\‚\„\:\;\=\?\@€ŠŒŽšœžŸ¡¢£¥¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ ]/
  // cannot begin with space
  var condition_2 = /^\S.*/
  return !string.match(e) && string.match(condition_2);
}

const redirect = (url) => {
  const isInternetExplorer = /*@cc_on!@*/false || !!document.documentMode;
  window.location.href = url;
  // Axios/fetch only executed when refreshing page on Internet Explorers
  if (isInternetExplorer && url.indexOf('switchToSite') !== -1) {
    window.location.reload(true);
  }
};

const updateObjState = (obj, attr, value) => {
  let tmpObj = { ...obj }
  tmpObj[attr] = value
  return tmpObj
}

const ANALYTIC_PRODUCT_NAME = 'Experiment'

const analyticTrack = (target, obj) => {
  if (window.analytics && window.optiID) {
    window.analytics.track(target, {
      userId: window.perPortal.user,
      groupId: window.optiID.masterCustomerId,
      productName: ANALYTIC_PRODUCT_NAME,
      subProductName: window.optiID.subProductName,
      isOptiUser: window.optiID.isOptiUser,
      companyName: window.optiID.OrganizationName,
      sitename: window.perPortal.siteName,
      ...obj,
    })
  }
}

const analyticPage = (name) => {
  if (window.analytics && window.optiID) {
    window.analytics.page(OPTI_RECS_PRODNAME, name, {
      userId: window.perPortal.user,
      groupId: window.optiID.masterCustomerId,
      productName: ANALYTIC_PRODUCT_NAME,
      subProductName: window.optiID.subProductName,
      sitename: window.perPortal.siteName,
      companyName: window.optiID.OrganizationName,
      roles: window.optiID.Roles?.map(role => role.Name) || [],
    });
  }
}

const analyticPageView = (url) => {
  let pageName = ''
  if (url.includes('/reporting/prodrecs/orders.page')) // Reports
    pageName = 'Report page - Product Recs - Orders'
  else if (url.includes('/reporting/prodrecs/engagement.page'))
    pageName = 'Report page - Product Recs - Site Engagement'
  else if (url.includes('/reporting/prodrecs/product.page'))
    pageName = 'Report page - Product Recs - Products'
  else if (url.includes('/reporting/prodrecs/pagetypes.page'))
    pageName = 'Report page - Product Recs - Page Types'
  else if (url.includes('/reporting/prodrecs/widgets.page'))
    pageName = 'Report page - Product Recs - Widgets'
  else if (url.includes('/reporting/prodrecs/categories.page'))
    pageName = 'Report page - Product Recs - Categories'
  else if (url.includes('/reporting/metrics.page'))
    pageName = 'Report page - Product Recs - Server Metrics'
  else if (url.includes('/reporting/advanced/highConHighTraf.page'))
    pageName = 'Report page - Product Recs - Conversion - High converting, high traffic'
  else if (url.includes('/reporting/advanced/highConLowTraf.page'))
    pageName = 'Report page - Product Recs - Conversion - High converting, low traffic'
  else if (url.includes('/reporting/advanced/poorConHighTraf.page'))
    pageName = 'Report page - Product Recs - Conversion - Poor converting, high traffic'
  else if (url.includes('/reporting/advanced/poorConLowTraf.page'))
    pageName = 'Report page - Product Recs - Conversion - Poor converting, low traffic'
  else if (url.includes('/reporting/search.page'))
    pageName = 'Report page - Product Recs - Search'
  else if (url.includes('/reporting/abtest.page'))
    pageName = 'Report page - Product Recs - AB tests'
  else if (url.includes('/reporting/email/daily.page'))
    pageName = 'Report page - Email Recs - Daily'
  else if (url.includes('/reporting/email/strategy.page'))
    pageName = 'Report page - Email Recs - Strategy'
  else if (url.includes('/reporting/email/position.page'))
    pageName = 'Report page - Email Recs - Position'
  else if (url.includes('/reporting/triggers/triggers/dashboard.page'))
    pageName = 'Report page - Trigger Messages - Dashboard'
  else if (url.includes('/reporting/triggers/triggers/daily.page'))
    pageName = 'Report page - Trigger Messages - Daily'
  else if (url.includes('/reporting/content/dailycreative.page'))
    pageName = 'Report page - Promoted Content - Daily creative'
  else if (url.includes('/reporting/content/creative.page'))
    pageName = 'Report page - Promoted Content - Creative'
  else if (url.includes('/reporting/content/content_ab.page'))
    pageName = 'Report page - Promoted Content - Promote AB'
  else if (url.includes('/config/activation.page?tab=custom'))
    pageName = 'Activation page - Custom tab'
  else if (url.includes('/config/activation.page?tab=default'))
    pageName = 'Activation page - Default tab'
  else if (url.includes('/config/activation.page'))
    pageName = 'Activation page - Default tab'
  else if (url.includes('/config/prodrecs/widgets/list.page'))
    pageName = 'Widget List Page'
  else if (url.includes('/config/prodrecs/widgets/config.page'))
    pageName = 'Widget Configuration Page'
  else if (url.includes('/sitemanagement/feeds/config.page?feed-tab=feed-schedule'))
    pageName = 'Feed Schedule page'

  if (pageName)
    analyticPage(pageName)
}

function formatBytes(bytes, decimals = 2) {
  bytes = parseFloat(bytes)
  if (!isFinite(bytes) || bytes <= 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${(bytes / Math.pow(k, i)).toFixed(dm)} ${sizes[i]}`
}

const formatNumberByK = (number, locale = 'en-gb', decimals = 2) => {
  number = parseFloat(number)
  if (!isFinite(number) || number <= 0) return '0'
  else if (number < 1)
    return number

  const k = 1000
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi', 'Sx', 'Sp']

  const i = Math.floor(Math.log(number) / Math.log(k))

  return `${formatNumber2Digits((number / Math.pow(k, i)).toFixed(dm), locale)}${sizes[i] || ''}`
}

const saveFile = (data, fileName) => {
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style = 'display: none'
  const blob = new Blob([data], { type: 'octet/stream' }),
    url = window.URL.createObjectURL(blob)
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}

export {
  allSupportedLocales,
  checkDateBefore,
  checkIfValidIP,
  createPage,
  detectLang,
  formatBytes,
  formatCurrency,
  zeroPad,
  getDateString,
  getOffsetHours,
  formatDateTime,
  formatDate,
  formatDateFromyyyyMMdd,
  formatNumber2Digits,
  formatNumberByK,
  formatNumberByLocale,
  time24toAM,
  isNumeric,
  isValid,
  observe,
  generateKey,
  getDisplayName,
  getNameFromEmail,
  redirect,
  updateObjState,
  analyticTrack,
  analyticPage,
  analyticPageView,
  saveFile,
  regexValidString,
  regexNoLeadingSpace,
  regexAlphaNumSpace,
  fireFoxClass
};